import { render, staticRenderFns } from "./IssuesOverview.vue?vue&type=template&id=10bcc132&"
import script from "./IssuesOverview.vue?vue&type=script&lang=ts&"
export * from "./IssuesOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10bcc132')) {
      api.createRecord('10bcc132', component.options)
    } else {
      api.reload('10bcc132', component.options)
    }
    module.hot.accept("./IssuesOverview.vue?vue&type=template&id=10bcc132&", function () {
      api.rerender('10bcc132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/issues/IssuesOverview.vue"
export default component.exports